import React, { useRef, useEffect } from "react";
import Sortable from "sortablejs";
import { RiDraggable } from "react-icons/ri";


function GenericTable({ headers, data, className, rowLink, groupName }) {
    const tableBodyRef = useRef(null);

    useEffect(() => {
        if (tableBodyRef.current) {
            Sortable.create(tableBodyRef.current, {
                animation: 300,
                easing: "ease-in-out", 
                group: groupName,
                store: {
                    get: function (sortable) {
                        var order = localStorage.getItem(sortable.options.group.name);
                        return order ? order.split('|') : [];
                    },
                    set: function (sortable) {
                        var order = sortable.toArray();
                        localStorage.setItem(sortable.options.group.name, order.join('|'));
                    }
                }
            });
        }
    }, [data, groupName]);

    const handleButtonClick = (event) => {
        event.stopPropagation(); // Stop event propagation to prevent row click
    };

    return (
        <div className={`overflow-x-auto shadow-lg rounded-lg ${className}`}>
            <table className="min-w-full bg-white border border-gray-200">
                <thead>
                    <tr className="bg-blue-500 text-white">
                        <th></th>
                        {headers.map((header, index) => (
                            <th
                                key={index}
                                className="text-left p-3 font-semibold tracking-wider"
                            >
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody ref={tableBodyRef}>
                    {data.map((row, rowIndex) => (
                        <tr
                            key={rowIndex}
                            onClick={() => (rowLink ? rowLink(row) : null)}
                            className="border-b hover:bg-gray-100 transition duration-150 ease-in-out cursor-pointer"
                        >
                            <td className="text-gray-800 drag-handle cursor-move p-2">
                                <i className="fas fa-grip-lines">
                                <RiDraggable />
                                </i>
                            </td>
                            {Object.keys(row)
                                .filter((key) => key !== "id")
                                .map((cellKey, cellIndex) => (
                                    <td
                                        key={cellIndex}
                                        className="py-2 px-2 items-center text-gray-700"
                                    >
                                        {React.isValidElement(row[cellKey]) ? (
                                            React.cloneElement(row[cellKey], {
                                                onClick: handleButtonClick,
                                            })
                                        ) : (
                                            row[cellKey]
                                        )}
                                    </td>
                                ))
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default GenericTable;
